import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.stanthonyUrl}/settings`,{params:searchParams});
    }

    get(Id){
      return this.http.get(`${environment.stanthonyUrl}/settings/`+Id);
    }

    edit(Id,formData){
      return this.http.put(`${environment.stanthonyUrl}/settings/`+Id,formData);
    }

    create(formData){
      return this.http.post(`${environment.stanthonyUrl}/settings`,formData);
    }

    delete(Id){
      return this.http.delete(`${environment.stanthonyUrl}/settings/`+Id);
    }

}
